exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border[data-v-760a1fd0] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 0;\n  top: 0;\n}\n.border img[data-v-760a1fd0] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
